import { useState } from 'react'
import {
  ActionIcon, Badge, Button, Group, Stack, Table, Title, Tooltip,
} from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useQuery } from '@tanstack/react-query'
import { IconEdit, IconPlus } from '@tabler/icons-react'
import type { Obra } from '@serkat/shared'
import { api } from '../../api/cliente'
import { useSesion } from '../auth/useSesion'
import { vacio } from '../../compartido/formato'
import { ModalObra } from './componentes/ModalObra'

export function ObrasPagina() {
  const { usuario } = useSesion()
  const [editando, setEditando] = useState<Obra | undefined>()
  const [abierto, modal] = useDisclosure(false)

  const { data: obras } = useQuery({
    queryKey: ['obras'],
    queryFn: () => api.get<Obra[]>('/obras?soloActivas=false'),
  })

  // Procura da de alta porque es quien topa con la obra faltante al emitir.
  const puedeEditar = usuario?.rol === 'PROCURA' || usuario?.rol === 'ADMIN'

  function abrir(o?: Obra) {
    setEditando(o)
    modal.open()
  }

  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Title order={2}>Obras</Title>
        {puedeEditar && (
          <Button leftSection={<IconPlus size={16} />} onClick={() => abrir()}>
            Nueva obra
          </Button>
        )}
      </Group>

      <Table.ScrollContainer minWidth={620}>
        <Table withTableBorder highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Nombre</Table.Th>
              <Table.Th w={140}>Código</Table.Th>
              <Table.Th>Ubicación</Table.Th>
              <Table.Th w={110}>Estado</Table.Th>
              <Table.Th w={60} />
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {(obras ?? []).map((o) => (
              <Table.Tr key={o.id}>
                <Table.Td>{o.nombre}</Table.Td>
                <Table.Td ff="monospace">{o.codigo}</Table.Td>
                <Table.Td>{vacio(o.ubicacion)}</Table.Td>
                <Table.Td>
                  <Badge color={o.activo ? 'teal' : 'gray'} variant="light" size="sm">
                    {o.activo ? 'Activa' : 'Terminada'}
                  </Badge>
                </Table.Td>
                <Table.Td>
                  {puedeEditar && (
                    <Tooltip label="Editar">
                      <ActionIcon variant="subtle" onClick={() => abrir(o)}>
                        <IconEdit size={16} />
                      </ActionIcon>
                    </Tooltip>
                  )}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>

      <ModalObra abierto={abierto} onCerrar={modal.close} inicial={editando} />
    </Stack>
  )
}
